module.exports = __webpack_public_path__ + "media/images/vp/icon.event-2effc7433713f4775f5ead0cd12c715c.svg";